import OverlayTips from "../OverlayTips";

function EmailNotificationsPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

EmailNotificationsPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".showCollapsibleBlockButton:eq(1)"), {
            messageKey: "tips.expand_section",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: 0,
            offsetY: -10
        });

        this.add($("#requestApproversBlockButton").parent(), {
            messageKey: "mail_notification.tips.settings.approvers",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                anchor: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: 150,
                offsetY: 10
            }
        });

        this.add($("#regularUsersBlockButton").parent(), {
            messageKey: "mail_notification.tips.settings.regular_users",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                anchor: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: 210,
                offsetY: -15
            }
        });

        this.add($("#messageParametersBlockButton").parent(), {
            messageKey: "mail_notification.tips.settings.message",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                anchor: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: 120,
                offsetY: -10
            }
        });

        this.add($("#errorProcessingBlockButton").parent(), {
            messageKey: "mail_notification.tips.settings.error",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                anchor: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: 160,
                offsetY: -20
            }
        });
    }
});

export default EmailNotificationsPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/actiplans/js/tips/managers/EmailNotificationsPageOverlayTipsManager.js